import React, { useEffect, useState } from 'react';
import SVG from 'react-inlinesvg';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { FormattedMessage } from 'react-intl';
import { toAbsoluteUrl } from '../../../_metronic/_helpers';
import css from './style.module.css';

const DialogBox = (props) => {
  const {
    openDialog,
    setOpenDialog,
    icon,
    iconColor,
    title,
    text,
    buttonOk,
    buttonYes,
    buttonNo,
    onConfirm,
  } = props;
  const onNothing = () => {
    setOpenDialog(false);
  };
  let onClickButton = onConfirm === undefined ? onNothing : onConfirm;
  function getIconName(icon) {
    switch (icon) {
      case 'success':
        return '/media/svg/icons/Code/Commit.svg';
      case 'warning':
        return '/media/svg/icons/Code/Warning-1-circle.svg';
      case 'error':
        return '/media/svg/icons/Code/Error-circle.svg';
      case 'question':
        return '/media/svg/icons/Code/Question-circle.svg';
      default:
        return '/media/svg/icons/Code/Info-circle.svg';
    }
  }
  function getIconColor(iconColor) {
    if (iconColor) return iconColor;
    switch (icon) {
      case 'success':
        return 'success';
      case 'warning':
        return 'warning';
      case 'error':
        return 'dander';
      case 'question':
        return 'danger';
      default:
        return 'info';
    }
  }

  return (
    <Modal
      size='m'
      show={openDialog}
      onHide={() => setOpenDialog(false)}
      backdrop='static'
      keyboard={false}
      aria-labelledby='example-modal-sizes-title-lg'
    >
      <Modal.Header>
        <Modal.Title id='confirm-dialog'>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Container>
          <div className={css.content}>
            <span
              className={`svg-icon svg-icon-${getIconColor(iconColor)}
             svg-icon-6x`}
            >
              <SVG src={toAbsoluteUrl(getIconName(icon))} />
            </span>
            <p className={css.text}> {text} </p>
          </div>
          {props.children}
        </Container>
      </Modal.Body>
      <Modal.Footer>
        {buttonNo && (
          <Button
            id='dialogNo'
            variant='secondary'
            onClick={() => setOpenDialog(false)}
          >
            <FormattedMessage id='GENERAL.BUTTON.NO' />
          </Button>
        )}{' '}
        {buttonYes && (
          <Button
            id='dialogYes'
            variant='info'
            onClick={() => {
              setOpenDialog(false);
              onClickButton();
            }}
          >
            <FormattedMessage id='GENERAL.BUTTON.YES' />
          </Button>
        )}
        {buttonOk && (
          <Button
            id='dialogOk'
            variant='info'
            onClick={() => {
              setOpenDialog(false);
              onClickButton();
            }}
          >
            <FormattedMessage id='GENERAL.BUTTON.OK' />
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
export default DialogBox;
